import React from "react"
import { Router } from "@reach/router"
import Blog from "../pages/blog"


const Groups = () => (
  <div>
    <Router>
      <Blog path="/blog/:id" />
    </Router>
  </div>
)

export default Groups